import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES } from '../constants';
import { OtpVerificationForm } from '../components/forms';

const OtpVerificationPage = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Get data from location state (passed from login page)
  const email = location.state?.email;
  const token = location.state?.token;
  const from = location.state?.from?.pathname || ROUTES.DASHBOARD;
  const autoSendOtp = location.state?.autoSendOtp || false;

  // If already authenticated, redirect to intended destination
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  // If no email provided, redirect to login
  if (!email) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  // Handle successful OTP verification
  const handleVerificationSuccess = result => {
    // The AuthContext will handle the redirect automatically
    console.log('Verification Success');
  };

  return (
    <OtpVerificationForm
      email={email}
      token={token}
      autoSendOtp={autoSendOtp}
      onSuccess={handleVerificationSuccess}
    />
  );
};

export default OtpVerificationPage;
